export { default as PageNotFound } from './PageNotFound';


// WEBPACK FOOTER //
// ./src/pages/PageNotFound/index.ts